var $8f1c9692e16dc5eb$exports = {};
$8f1c9692e16dc5eb$exports = {
    "Empty": `Prazen`
};


export {$8f1c9692e16dc5eb$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
